import * as types from '@/constants/mutationTypes'
import { IN_PROGRESS_PROJECT } from '@/constants/projectStatuses'

const state = {
  queryProjects: {
    supportManager: '',
    contactPm: '',
    search: '',
    estCompletion: '',
    estStartDate: '',
    currentTab: IN_PROGRESS_PROJECT.id,
    page: 1
  }
}
const getters = {
  queryProjects: state => state.queryProjects
}
const actions = {
  setQueryProjects ({commit}, data) {
    commit(types.SET_QUERY_PROJECTS, {data})
  }
}
const mutations = {
  [types.SET_QUERY_PROJECTS] (state, {data}) {
    state.queryProjects = data
  }}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/QueryProjects/modules/store.js